var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"d-flex flex-wrap text-center p-0"},_vm._l((_vm.handleTemplates),function(template,index){return _c('ItemViewTemplate',{key:index,attrs:{"item":template}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }